import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { Injectable, inject } from '@angular/core';
import { AppGeneralStateService } from 'src/app/app-general-state.service';

@Injectable()
export class PrimaryInterceptor implements HttpInterceptor {
  urlsToNotUse: Array<string>;

  //SERVICES
  private router = inject(Router);
  #_appGeneralState = inject(AppGeneralStateService);

  constructor() {
    this.urlsToNotUse = [
      'credential/lanaisettinginit',
      'credential/validateapnLink',
      'credential/getinitdata',
      'credential/getUserdetailsbyuserId',
      'credential/GetAuthenticatedUserData',
    ];
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const date = new Date();
    const timezoneOffset = date.getTimezoneOffset() / 60;
    const userName = this.#_appGeneralState.userName;

    if (this.isValidRequestForInterceptor(req.url)) {
      //This handles http calls that are secured

      const apiKey = this.getCookie('lni');

      if (apiKey == null || apiKey == '') {
        this.router.navigateByUrl('/badroute');
      }
      let modifiedRequest = req.clone({
        setHeaders: {
          ApiKey: this.getCookie('lni'),
          'x-api-key': this.getCookie('spa'),
          TIMEZONEOFFSET: `${timezoneOffset}`,
          USERNAME: `${userName}`,
        },
      });

      return next.handle(modifiedRequest);
    } else {
      //this handles public/unsecured http calls

      const authReq = req.clone({
        setHeaders: {
          TIMEZONEOFFSET: `${timezoneOffset}`,
          USERNAME: `${userName}`,
        },
      });

      return next.handle(authReq);
    }
  }

  getLanaiTicket(): string {
    let ticketValue: any = '';

    const name: string = 'lanai-ticket';
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) ticketValue = parts.pop().split(';').shift();

    return ticketValue;
  }

  private getCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return '';
  }

  private isValidRequestForInterceptor(requestUrl: string): boolean {
    let ii: number = 0;

    let isCallSecured: boolean = true;

    for (ii = 0; ii < this.urlsToNotUse.length; ii++) {
      const unprotected: boolean = requestUrl.toLowerCase().includes(this.urlsToNotUse[ii].toLowerCase());

      if (unprotected) {
        isCallSecured = false;
        break;
      }
    }

    return isCallSecured;
  }
}
